import React from 'react';
import { Block } from 'slate';

import InternalLink from './internalLink.component';

export { default as InsertInternalLinkButton } from './insertInternalLinkButton.component';

export const INTERNAL_LINK_INLINE_TYPE = 'internal-link';

const internalLinkPlugin = () => ({
  renderInline: (props, editor, next) => {
    if (props.node.type === INTERNAL_LINK_INLINE_TYPE) {
      return <InternalLink {...props}/>;
    }
    return next();
  },
  schema: {
    document: {
      last: { type: 'paragraph' },
      normalize: (editor, { code, node }) => {
        switch (code) {
          case 'last_child_type_invalid': {
            const paragraph = Block.create('paragraph');
            return editor.insertNodeByKey(node.key, node.nodes.size, paragraph);
          }
          default:
            return;
        }
      },
    },
    inlines: {
      [INTERNAL_LINK_INLINE_TYPE]: {
        isVoid: true,
      },
    },
  },
  commands: {
    insertInternalLink: (editor, contentId, label) => editor.insertInline({
      type: INTERNAL_LINK_INLINE_TYPE,
      isVoid: true,
      data: { contentId, label },
    }),
  },
  serialize: node => {
    if (node.type === INTERNAL_LINK_INLINE_TYPE) {
      const label = node.data.get('label');
      return (<label style={{ color: '#007bff', textDecoration: 'underline' }}>{label}</label>);
    }
  },
});

export default internalLinkPlugin;
